<template>
  <div class="page--full product  bg-violet">
    <el-row type="flex" class="row--full flex-wrap">
      <el-col :sm="9" class="product-header">
        <div class="product-header__wrapper">
          <!-- <transition name="fadeInUp"> -->
          <h1 class="product-header__title" v-if="showContentByPaging">
            <span class="header"
              >We create<br />companies <br class="hidden-xs-only" />from<br />scratch</span
            >
          </h1>
          <!-- </transition> -->
          <!-- <transition name="fadeInUp"> -->
          <div class="product-switch" v-if="showContentByPaging">
            <div
              v-for="(item, index) in products"
              :key="index"
              class="product-switch__option"
              :class="{ active: index === activeProduct }"
              @click="switchProduct(index)"
            >
              <img :src="item.switchSrc" :alt="item.alt" />
              <span>{{ item.name }}</span>
            </div>
          </div>
          <!-- </transition> -->
        </div>
      </el-col>
      <el-col :sm="15" class="product-content">
        <div
          v-for="item in activeProducts"
          :key="item.name"
          :class="`product-content__wrapper--${item.layout}`"
        >
          <img class="product-image" :src="item.src" :alt="item.alt" />
          <!-- <transition name="fadeInUp"> -->
          <section class="product-description" v-if="showContentByPaging">
            <h2>{{ item.name }}</h2>
            <article class="hidden-sm-and-up" v-html="item.articleShort" />
            <article class="hidden-xs-only" v-html="item.article" />
          </section>
          <!-- </transition> -->
        </div>
        <ul class="product-switch--mobile hidden-sm-and-up">
          <li
            class="switch"
            v-for="(item, index) in products"
            :key="index"
            :class="{ active: index === activeProduct }"
            @click="switchProduct(index)"
          ></li>
        </ul>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import contentAnimation from '@/mixins/contentAnimation';
// import ImageWithLoader from '@/components/ImageWithLoader.vue';

export default {
  mixins: [contentAnimation],
  // components: {
  //   ImageWithLoader,
  // },
  data() {
    return {
      activeProduct: 0,
      products: [
        {
          name: 'Nimble',
          switchSrc: require('@/assets/images/icons/nimble.svg'),
          src: require('@/assets/images/nimble.png'),
          alt: 'Nimble',
          articleShort: `<p>Enterprise collaboration displays that get meetings started faster.</p>`,
          article: `
            <p>Enterprise collaboration displays that get meetings started faster.</p>
            <p>Nimble is a full stack software platform that powers enterprise collaboration displays. The average meeting starts 12 minutes late - Nimble gets meetings started faster, with smart switching, universal casting, and a smart interface built for large meeting room.</p>
            <p>Launching July 2019</p>
          `,
          layout: 'vertical',
        },
        {
          name: 'In Stealth',
          switchSrc: require('@/assets/images/icons/stealth.svg'),
          src: require('@/assets/images/stealth.png'),
          alt: 'In Stealth',
          articleShort: `<p>Interactive retail kiosks that drive shopper engagement.</p>`,
          article: `
            <p>Interactive retail kiosks that drive shopper engagement.</p>
            <p>We're working on the next evolution in retail, bringing storytelling front and center while bridging the online-to-offline gap for shoppers and retailers alike.</p>
            <p><span>Curious to know more?</span></p>
            <p>Launching August 2019</p>
          `,
          layout: 'landscape',
        },
      ],
    };
  },
  computed: {
    activeProducts() {
      return this.products.filter((product, index) => index === this.activeProduct);
    },
  },
  methods: {
    switchProduct(index) {
      this.activeProduct = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-header {
  display: flex;
  align-items: center;
  line-height: 1;
  padding: 3.5rem 2rem 0rem;
  overflow: hidden;
  @media (min-width: $sm) {
    padding-top: 0;
    padding-left: 12%;
  }
  @media (min-width: $xl) {
    padding-left: 10%;
  }
  &__title {
    color: $color-white;
    @media (min-width: $sm) {
      margin-bottom: 2.5rem;
    }
    @media (min-width: $xl) {
      margin-bottom: 4rem;
    }
  }
}
.product-switch {
  display: none;
  @media (min-width: $sm) {
    display: flex;
  }
  justify-content: space-around;
  &__option {
    font-weight: 600;
    margin-right: 1rem;
    color: $color-white;
    border: 1px solid $color-white;
    border-bottom-width: 3px;
    width: 6.5rem;
    height: 6.5rem;
    opacity: 0.3;
    transition: opacity 0.3s ease;
    @media (min-width: $xl) {
      width: 9rem;
      height: 9rem;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &:hover {
      opacity: 1;
      cursor: pointer;
    }
    &.active {
      opacity: 1;
    }
    img {
      margin-bottom: 1rem;
    }
  }
  &--mobile {
    position: absolute;
    bottom: 0rem;
    display: flex;
    z-index: 1;
    li {
      opacity: 0.3;
      width: 1rem;
      height: 1rem;
      border-radius: 0.5rem;
      background: $color-white;
      &:not(:last-child) {
        margin-right: 1.5rem;
      }
      &.active {
        opacity: 1;
      }
    }
  }
}

.product-content {
  overflow: hidden;
  padding: 0 1rem;
  position: relative;
  @media (min-width: $sm) {
    padding: 0 5rem;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $color-primary;
  &__wrapper {
    &--vertical {
      padding: 0 0.25rem;
      position: relative;
      min-height: 55vh;
      @media (min-width: $md) {
        min-height: 0;
        max-width: 41rem;
      }
      @media (min-width: $xl) {
        max-width: 50rem;
      }
      .product-image {
        position: absolute;
        left: 0;
        right: 0;
      }
      .product-description {
        padding: 70% 5% 0;
        @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
          (max-width: $xs) {
          padding-top: 66%;
        }
        @media (min-width: $sm) {
          padding: 64% 5% 0;
        }
      }
    }
    &--landscape {
      min-height: 55vh;
      @media (min-width: $sm) {
        min-height: 0;
        width: 85%;
      }
      .product-image {
        position: absolute;
        top: 2rem;
        right: 50%;
        transform: translate(50%);
        height: 80%;
        @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
          (max-width: $xs) {
          top: 1rem;
        }
        @media (min-width: $sm) {
          position: absolute;
          top: initial;
          bottom: 0;
          right: 15%;
          height: 80%;
          transform: none;
        }
      }
      .product-description {
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 1rem 10% 1.5rem;
        background-color: $color-primary;
        @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
          (max-width: $xs) {
          padding-bottom: 1rem;
        }
        @media (min-width: $sm) {
          position: static;
          padding: 0;
          background-color: transparent;
          width: 40%;
        }
      }
    }
  }
}

.product-description {
  color: $color-white;
  padding: 0 0.5rem;
  @media (min-width: $sm) {
    padding: 1.125rem 1.5rem;
  }
  h2 {
    font-size: 1.625rem;
    margin: 0;
    margin-bottom: 0.625rem;
    @media (min-width: $sm) {
      font-size: 2.25rem;
      margin-bottom: 1.75rem;
    }
  }
  article {
    opacity: 0.7;
    font-size: 1rem;
    @media (min-width: $sm) {
      font-size: 0.875rem;
      line-height: 1.29;
    }
    @media (min-width: $xl) {
      font-size: 1.25rem;
      line-height: 1.4;
    }
  }
  article /deep/ p {
    margin-bottom: 0.625rem;
    &:nth-child(2) {
      margin-bottom: 2rem;
      span {
        border-bottom: 1px solid rgba(255, 255, 255, 0.7);
      }
    }
    @media (min-width: $sm) {
      display: block;
    }
  }
}

.fadeInUp-enter-active {
  animation: fadeInUp 0.5s;
}
.fadeInUp-leave-active {
  animation: fadeInUp 0.5s reverse;
}
</style>
